import { getContributionStatusView } from './getContributionStatusView';

export const getLeadMagnetStatusView = getContributionStatusView;
